<div *ngIf="items" class="wrap-external" #container>
  <div class="wrap-internal" [class.disabled-semitransparent]="disabled">
    <div
      class="selected-block"
      [style.margin-left]="_selectedItemIndex === 0 ? 0 : itemsSizeInfo[_selectedItemIndex].x - 1 + 'px'"
      [style.width]="itemsSizeInfo[_selectedItemIndex].width + 1 + 'px'"
    ></div>
    <div
      *ngFor="let item of items; let index = index; let last = last"
      class="item"
      [attr.index]="index"
      [class.selected]="index === _selectedItemIndex"
      [class.highlight]="index === _selectedItemIndex && highlightSelected"
      (click)="!disabled ? changeItem(index) : null"
    >
      <h4 [class.largest-fs]="items.length < 3">{{ item }}</h4>
      <div *ngIf="showDividers && !last" class="divider-line" [class.hidden]="index === _selectedItemIndex"></div>
    </div>
  </div>
</div>
